import React, { Profiler, useState } from "react";
import { Link } from "react-router";
import InputLineContainer from "../components/InputLine";
import DemoData from "../utils/DemoData";
import { RollRedrawObserver } from "../utils/RollRedrawObserver";
import '../components/RydProjectContainers.css';

function EurydiceProfilingHome() {

    const [redrawObserver, setRedrawObserver] = useState(new RollRedrawObserver());

    const mazurka = DemoData.mazurkaChoroRydProject();

    return (
        <div>
            <h1>Eurydice Profiling Home</h1>
            <h2>Piano roll: mazurka</h2>
            <Profiler id="mazurka" onRender={(id, phase, actualDuration) => {
                console.log(`Profiler ${id} (${phase}) took ${actualDuration}ms`);
            }}>
                <InputLineContainer
                    project={mazurka}
                    // noteRange={{ min: 50, max: 70 }}
                    // timeSignature={mazurka.contextFrame.timeSignature}
                    redrawObserver={redrawObserver} />
            </Profiler>
        </div>
    );
}

export {
    EurydiceProfilingHome
};